import { KEYCLOAK_CLIENT_ID, KEYCLOAK_TOKEN_URL, KEYCLOAK_REDIRECT_URI } from 'constants/apiUrl';
import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import cryptoBrowserify from "crypto-browserify";
import axios from 'axios';
import qs from "querystring";
import { getOAuth2Profile } from 'reducers/settingsReducer/settingsReducer';


export const ACTION_TYPES = {
    GENERATE_VERIFIER: 'GENERATE_VERIFIER',
    GENERATE_CHALLENGE: 'GENERATE_CHALLENGE',
    GENERATE_STATE: 'GENERATE_STATE',
    GENERATE_TOKEN: 'GENERATE_TOKEN',
    RESET: 'RESET'
};

const base64URLEncode = (str) => {
  return str
    .toString("base64")
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");
};

const sha256 = (buffer) => {
  return cryptoBrowserify.createHash("sha256").update(buffer).digest();
};

const initial = {
    value: 0,
    accessToken: "",
    refreshToken: "",
    idToken: "",
    verifier: base64URLEncode(cryptoBrowserify.randomBytes(32)),
    challenge: "",
    state: base64URLEncode(cryptoBrowserify.randomBytes(32)),
    loading: false
};

// REDUCER
const authReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GENERATE_TOKEN):
      return {
        ...state,
        loading: true,
      };
    case FAILURE(ACTION_TYPES.GENERATE_TOKEN):
        return {
          ...state,
          loading: false,
          errorMessage: "Gagal Ambil Token",
        };
    case ACTION_TYPES.GENERATE_VERIFIER:
      return {
        ...state,
        verifier : base64URLEncode(cryptoBrowserify.randomBytes(32))
      };
    case ACTION_TYPES.GENERATE_CHALLENGE:
      return {
        ...state,
       challenge : base64URLEncode(sha256(state.verifier))
      };
    case ACTION_TYPES.GENERATE_STATE:
      return {
        ...state,
        state : base64URLEncode(cryptoBrowserify.randomBytes(32))
      };
    case ACTION_TYPES.GENERATE_STATE:
      return {
        ...state,
        state : base64URLEncode(cryptoBrowserify.randomBytes(32))
      };
    case SUCCESS(ACTION_TYPES.GENERATE_TOKEN):
        let res = action.payload.data;
        return {
            ...state,
            accessToken : res.access_token,
            idToken : res.id_token,
            loading: false,
        };
    case ACTION_TYPES.RESET:
      return { ...initial };
    default:
      return state;
  }
};

export default authReducer;

export const generateVerifier = () => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.GENERATE_VERIFIER,
  });
  return result;
};

export const generateChallenge = () => async dispatch => {
    const result = await dispatch({
      type: ACTION_TYPES.GENERATE_CHALLENGE,
    });
    return result;
  };

export const generateState = () => async dispatch => {
    const result = await dispatch({
        type: ACTION_TYPES.GENERATE_STATE,
    });
    return result;
};

export const getKeycloakToken = (receivedCode, verifier) => async (dispatch) => {
    const body = {
        client_id: KEYCLOAK_CLIENT_ID,
        code_verifier: verifier,
        grant_type: "authorization_code",
        code: receivedCode,
        redirect_uri: KEYCLOAK_REDIRECT_URI,
    };
    
    const result = await dispatch({
      type: ACTION_TYPES.GENERATE_TOKEN,
      payload: axios.post(KEYCLOAK_TOKEN_URL, qs.stringify(body), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }),
    });
    dispatch(getOAuth2Profile(result.action.payload.data.access_token, result.action.payload.data.id_token));
    return result;
  };

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
